export default __webpack_public_path__ + "static/media/e2.37d65ddb.jpeg";